import update from 'immutability-helper';
import { sortBy } from 'lodash-es';
import {
  COLUMN_VISIBLE_TOGGLED,
  COLUMN_ATTRIBUTES_SET,
  COLUMN_SECURITY_GROUPS_SET,
  SET_COLUMN_VISIBILTY,
} from './table-columns.action';

import { INITIAL_STATE } from './table-columns.state';

export function createChildren(parentKey, orderKey, children) {
  const newChildren = {};

  children.forEach((child) => {
    newChildren[child.key] = {
      key: child.key.toLowerCase(),
      label: child.key,
      orderable: false,
      type: child.dataType.toLowerCase(),
      group: 'attribute',
      parent: 'attrs',
    };

    // sorted col based on IPORT-4953  uesed common attrs
    // ('machine serial number', 'telematics serial number', 'year') are Genie common attrs
    const sortAttrsList = [
      'make',
      'model',
      'model year',
      'vin',
      'equipment number',
      'machine serial number',
      'telematics serial number',
      'year',
    ];

    //our elasticSearch will only sort correctly on like text type attrs at the moment.
    //we can use child.dataType && child.dataType.toLowerCase() === 'text' when search api fixed for elastic un-mapped fields
    if (sortAttrsList.includes(child.key.toLowerCase())) {
      newChildren[child.key].orderable = true;
      newChildren[child.key].sort_key = `attrs.${child.key.toLowerCase()}.keyword`;
    }
  });

  const sortedObject = Object.keys(newChildren)
    .sort((a, b) => a.localeCompare(b))
    .reduce((acc, k) => ({ ...acc, [k]: newChildren[k] }), {});

  return sortedObject;
}

export function visible(permissions, value) {
  return permissions.includes(value);
}

export const TableColumnsReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SET_COLUMN_VISIBILTY: {
      return update(state, {
        columns: {
          security_groups: {
            visible: { $set: visible(payload.permissions, 'admin.securitygroups') },
          },
          transferrable: {
            visible: { $set: visible(payload.permissions, 'devices.transfer') },
          },
          account: {
            visible: { $set: visible(payload.permissions, 'admin.subaccounts') },
          },
          device_id: {
            visible: { $set: visible(payload.permissions, 'devices') },
          },
        },
      });
    }
    case COLUMN_SECURITY_GROUPS_SET: {
      return update(state, {
        columns: {
          security_groups: {
            options: { $set: payload },
          },
        },
      });
    }
    case COLUMN_ATTRIBUTES_SET: {
      const attrChildren = createChildren('attributes', 'attrs.', payload);
      return update(state, {
        columns: {
          attributes: {
            children: { $set: attrChildren },
          },
        },
      });
    }
    case COLUMN_VISIBLE_TOGGLED: {
      const selected = _.find(
        state.selected,
        (columnSelected) => columnSelected.key === payload.key,
      );

      if (selected) {
        return update(state, {
          selected: {
            $apply: (selected) => selected.filter((col) => col.key !== payload.key),
          },
        });
      } else {
        const { selected, columns_order } = state;
        //if col not order just used big number for sorting
        let orderdArray = [...selected, payload].map((col) => ({
          ...col,
          order: columns_order.indexOf(col.key) !== -1 ? columns_order.indexOf(col.key) : 999,
        }));

        return {
          ...state,
          selected: sortBy(orderdArray, 'order'),
        };
      }
    }

    default:
      return state;
  }
};
